// ##############################
// // // Constants
// #############################

// VID-4091: implement use of this variable
export const MIN_USERLEVEL_ALL_CATEGORIES = 35; // users at or below this level have access to limited categories
